import React, { useEffect, useState } from "react";
import Leo from "../../../assets/images/Leo.png";

import StorefrontTwoToneIcon from "@mui/icons-material/StorefrontTwoTone";
import { Menu, MenuItem } from "@mui/material";
import axios from "axios";
import jwt_decode from "jwt-decode";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LogoutIcon from "@mui/icons-material/Logout";
import CottageIcon from "@mui/icons-material/Cottage";
import StorefrontIcon from "@mui/icons-material/Storefront";
import NotificationBell from "../../../components/NotificationBell.tsx";
import SideBarCourier from "./SidebarCourier.tsx";

const NavbarCourier = () => {
  // const [totalNotification, setTotalNotification] = useState(null)

  // const sendDataToParent = (number) => {
  //     // console.log('Total notification in top header', number);
  //     setTotalNotification(number);
  // };

  const apiAddress = process.env.REACT_APP_SECRET;
  //restaurant selection start
  const [userid, setUserId] = React.useState("");
  // const [restaurantList, setRestaurantList] = React.useState([]);
  const [userData, setuserData] = useState();
  const token = jwt_decode(localStorage.getItem("gotasteadmintoken") || "");
  // const [restaurant, setrestaurantName] = useState(
  //   JSON.parse(localStorage.getItem('parentrestaurant') || '')
  // );
  // React.useEffect(() => {
  //   // var decodedData = {};
  //   if (token != null) {
  //     try {
  //       // decodedData = jwt_decode(token)
  //       // console.log(decodedData)
  //       setuserData(token?.UserName);
  //       setUserId(token?.UserId);

  //       // setTokenData(decodedData)
  //     } catch (error) {}
  //   }
  //   console.log(userData);
  //   axios
  //     .get(apiAddress + '/api/RestaurantUserMapper/getbyuserid/' + token.UserId)
  //     .then((response) => {
  //       console.log(response.data);

  //       var list = [];
  //       response.data.map((dt, i) => {
  //         var obj = {
  //           id: dt.restaurantId,
  //           name: dt.restaurantName,
  //           imgUrl: dt.imgUrl,
  //         };
  //         list.push(obj);
  //       });
  //       setRestaurantList(list);
  //     });
  // }, []);

  // useEffect(() => {
  //   setrestaurantName(JSON.parse(localStorage.getItem('parentrestaurant')));
  //   console.log(JSON.parse(localStorage.getItem('restaurant')));
  // }, []);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const restaurantListopen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  console.log(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  // const handleMenuSelect = (props) => {
  //   console.log(props);
  //   localStorage.setItem('restaurant', JSON.stringify(props));
  //   localStorage.setItem('parentrestaurant', JSON.stringify(props));
  //   localStorage.setItem('restaurantChanged', 'newRestaurantSeelected');

  //   // Broadcast the change to other tabs
  //   const broadcastChannel = new BroadcastChannel('storage_change_channel');
  //   broadcastChannel.postMessage('restaurantChanged');

  //   window.dispatchEvent(new Event('storage'));
  //   handleClose();
  // };
  //restaurant selection end

  //user logout dropdown start

  const [useranchorEl, setuseranchorEl] = React.useState(null);
  const userOpen = Boolean(useranchorEl);
  const handleUserClick = (event) => {
    setuseranchorEl(event.currentTarget);
  };
  const handleUserClose = () => {
    setuseranchorEl(null);
  };

  //user logout dropdown end

  return (
    <>
      <div
        className=" d-flex justify-content-between"
        style={{ height: "3.5rem", backgroundColor: "#56595b" }}
      >
        <div className="">
          <div className="d-flex flex-row">
            <div>
              <SideBarCourier />
            </div>
            <h4
              className="mt-1"
              style={{ color: "white", marginLeft: "1rem" }}
              onClick={() => {
                window.location.href = "/";
              }}
            >
              Go
              <span style={{ color: "#e5e5e5", fontWeight: "700" }}>Taste</span>
            </h4>
          </div>
        </div>
        <div
          className="d-flex"
          style={{ marginRight: "1rem", marginTop: "10px", gap: "10px" }}
        >
          {/* <NotificationBell/>
                    <h5 style={{ color: 'white', marginRight: '1rem' }}>Welcome, Leo</h5>
                    <img src={Leo} alt='leo' style={{ width: '2rem', height: '2rem' }} />
                    <h5 style={{ color: 'white', marginRight: '1rem', cursor: "pointer" }} onClick={() => {
                        localStorage.removeItem('gotasteadmintoken');
                        localStorage.removeItem('restaurant');
                        window.location.href = `/`;
                    }}>Log Out</h5>  */}
          {/* User dropdown menu start */}
          {/* <Menu
                        id="basic-menu"
                        anchorEl={useranchorEl}
                        open={userOpen}
                        onClose={handleUserClose}
                        MenuListProps={{
                        'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem onClick={handleUserClose}>Welcome Leo</MenuItem>
                        <MenuItem onClick={handleUserClose}>
                            <div className='Navlogout'>
                                <LogoutIcon />
                                <p onClick={() => {
                                    localStorage.removeItem('gotasteadmintoken');
                                    localStorage.removeItem('restaurant');
                                    window.location.href = `/`;
                                }}>Log out</p>
                            </div>
                            
                            </MenuItem>
                      
                    </Menu> */}
          {/* <Menu
            id='basic-menu'
            anchorEl={anchorEl}
            open={restaurantListopen}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            {restaurantList?.map((rs, i) => {
              return (
                <MenuItem onClick={() => handleMenuSelect(rs)}>
                  <div className='restaurantDropDown'>
                    <StorefrontIcon />
                    <p>{rs.name}</p>
                  </div>
                </MenuItem>
              );
            })}
          </Menu> */}

          {/* <div className="NavNotification">
            <NotificationBell />
          </div> */}

          <div className="NavIcon" onClick={handleClick}>
            {/* <img src={menu5} alt='img' style={{ width: '1.3rem', height: '1.3rem' }} /> */}
            <StorefrontIcon />
            {/* {restaurant != null ? (
              <div className=''>
                {restaurant.imgUrl == '' ? (
                  
                ) : (
                  <img
                    src={restaurant.imgUrl}
                    alt='img'
                    style={{ width: '1.3rem', height: '1.3rem' }}
                  />
                )}
              </div>
            ) : (
              <StorefrontIcon />
            )} */}
          </div>
          {/* {restaurant != null ? (
            <div className='mt-1'>
              <span style={{ color: 'white' }}>{restaurant.name}</span>
            </div>
          ) : (
            ''
          )} */}
          <div className="mt-1">
            <span style={{ color: "white" }}>Burger King</span>
          </div>

          {/* <h5 style={{ color: 'white', marginRight: '1rem' }}>Welcome, Leo</h5> */}
          <div className="NavIcon" onClick={handleUserClick}>
            <img
              src={Leo}
              alt="leo"
              style={{ width: "1.8rem", height: "1.8rem" }}
            />
          </div>
          <div className="mt-1">
            <span style={{ color: "white" }}>Welcome {token.UserName}</span>
          </div>
          {/* <h5 style={{ color: 'white', marginRight: '1rem', cursor: "pointer" }} onClick={() => {
                            localStorage.removeItem('gotasteadmintoken');
                            localStorage.removeItem('restaurant');
                            window.location.href = `/`;
                        }}>Log Out</h5> */}
          {/* User dropdown menu start */}
          <Menu
            id="basic-menu"
            anchorEl={useranchorEl}
            open={userOpen}
            onClose={handleUserClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={handleUserClose}>Welcome {userData}</MenuItem>
            <MenuItem
              onClick={() => {
                localStorage.removeItem("gotasteadmintoken");
                localStorage.removeItem("restaurant");
                localStorage.removeItem("parentrestaurant");
                localStorage.removeItem("permissions");
                // In the tab where storage changes
                localStorage.setItem("myKey", "myValue");

                // Broadcast the change to other tabs
                const broadcastChannel = new BroadcastChannel(
                  "storage_change_channel"
                );
                broadcastChannel.postMessage("storage_changed");

                window.dispatchEvent(new Event("storage"));
                window.location.href = `/`;
              }}
            >
              <div className="Navlogout">
                <LogoutIcon />
                <p>Log out</p>
              </div>
            </MenuItem>
          </Menu>
          {/* User dropdown menu end */}
        </div>
      </div>
    </>
  );
};

export default NavbarCourier;
